import { resolveEnvironment, vellumApiSdk } from "@vellum/micro-app-auth";
import { appJobUrl, stringListParam, useSearchParamState } from "@vellum/ui";
import { DispatchBoardView } from "@vellum/ui/dispatch";

/** No regions picked means every region. */
const ALL_REGIONS: string[] = [];

export function DispatchPage() {
  const [regionIds, setRegionIds] = useSearchParamState(
    "regions",
    ALL_REGIONS,
    stringListParam,
  );

  return (
    <DispatchBoardView
      load={(ids) =>
        vellumApiSdk.adminGetDispatchBoard({
          query: ids.length ? { region_ids: ids } : undefined,
        })
      }
      loadNurseRoute={(nurseId) =>
        vellumApiSdk.adminGetDispatchNurseRoute({ path: { nurse_id: nurseId } })
      }
      jobHref={(job) => appJobUrl(resolveEnvironment(), job.job_type, job.id)}
      regionIds={regionIds}
      onRegionIdsChange={setRegionIds}
    />
  );
}
